'use strict';

var base = require('base/checkout/formErrors');
var core = require('core/checkout/formErrors');

var scrollAnimate = require('core/components/scrollAnimate');

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
function loadFormErrors(parentSelector, fieldErrors) { // eslint-disable-line
    // Display error messages and highlight form fields with errors.
    $.each(fieldErrors, function (attr) {
        var formField = $('*[name=' + attr + ']', parentSelector);
        // aria-invalid tells screen readers the field failed; it goes on the field's next change, as the red mark does
        formField.addClass('is-invalid')
        .attr('aria-invalid', 'true')
        .one('change', function () {
            $(this).removeAttr('aria-invalid');
        });

        var message = formField.siblings('.invalid-feedback');
        if (!message.length && formField.attr('aria-describedby')) {
            // the card number's message sits outside its wrapper and stays displayed: empty it when the value changes
            message = $('#' + formField.attr('aria-describedby'));
            formField.one('change', function () {
                message.html('');
            });
        }
        message.html(fieldErrors[attr]);
        // a field with no description gets one pointing at its message, so a screen reader reads why it failed
        if (message.length > 0 && formField.length > 0 && !formField.attr('aria-describedby')) {
            var messageId = message.attr('id') || formField.attr('id') + 'InvalidMessage';
            message.attr('id', messageId);
            formField.attr('aria-describedby', messageId);
        }

        // Add invalid class to labels as well
        var label = $(`label[for="${formField.attr('id')}"]`);
        label.addClass('is-invalid');
    });

    // The payment form's Update Address button sits in the "Same as Shipping Address" summary and its handler toggles
    // the billing form (address.js, LEG-615). There, open the billing form only when a failed field is inside it and
    // it is hidden, by setting what that handler sets: address mode "details", summary hidden, box unchecked. A card
    // error then leaves the box alone, and a second error object cannot close the form again. Every other form keeps
    // the click.
    var billingSummary = $(parentSelector).find('.shipping-address-as-billing-address');
    var updateAddressButton = $(parentSelector).find('.btn-show-details');
    var billingFieldFailed = false;
    if (billingSummary.length > 0) {
        var billingForm = billingSummary.closest('form');
        var billingFields = billingForm.find('.billing-address');
        billingFieldFailed = billingFields.find('[aria-invalid="true"]').length > 0;
        if (billingFieldFailed && !billingFields.is(':visible')) {
            billingForm.attr('data-address-mode', 'details');
            billingSummary.removeClass('d-flex');
            billingForm.find('input.btn-add-new').prop('checked', false).removeAttr('checked');
        }
        // The payment step calls this once per error object: stop the scroll an earlier object started, so the page
        // makes one scroll to the last target instead of going down to one field and back up to another (LEG-615)
        $('html, body').stop(true);
    } else if (updateAddressButton.length > 0) {
        updateAddressButton.trigger('click');
    }

    // When a billing or contact field failed, scroll to the first visible failed field instead of the form's top, so
    // that on a phone it does not end under the fixed Place Your Order bar (LEG-615); card errors alone and every other
    // form keep the scroll to the form's top. The same field takes the focus below.
    var firstFailedField = $(parentSelector).find('[aria-invalid="true"]').filter(':visible').first();
    if (billingFieldFailed && firstFailedField.length > 0) {
        scrollAnimate(firstFailedField);
    } else {
        // Animate to top of form that has errors
        scrollAnimate($(parentSelector));
    }

    // Move the focus to the first failed field for screen readers, leaving the scroll above as it is
    if (firstFailedField.length > 0) {
        firstFailedField[0].focus({ preventScroll: true });
    }
}

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
    //default clientSideValidation.js will remove .is-invalid only for html5 errors
    //let our manual call here clear all messaging on .invalid-feedback always
    $(parentSelector).find('.is-invalid').removeClass('is-invalid');
    $(parentSelector).find('[aria-invalid]').removeAttr('aria-invalid');
    $(parentSelector).find('.invalid-feedback').html('');
    $('.error-message').hide();
}

base.loadFormErrors = loadFormErrors;
core.loadFormErrors = loadFormErrors;
base.clearPreviousErrors = clearPreviousErrors;
core.clearPreviousErrors = clearPreviousErrors;

module.exports = base;
module.exports = core;
